export default "__VITE_ASSET__BxJgeyYS__"